import { isMaxPlatform, isTelegramPlatform } from "./platform";

export const supportsTelegramSdk = (): boolean => isTelegramPlatform();

export const supportsPreparedShareMessage = (): boolean => isTelegramPlatform();

export const supportsMaxBridge = (): boolean => isMaxPlatform();

export const supportsBackButton = (): boolean => isTelegramPlatform() || isMaxPlatform();

export const supportsAddToHomeScreen = (): boolean => isTelegramPlatform();

